import { Component } from '@angular/core';
import { SectionEnrollmentEditor } from '../../../ui/admin/section-enrollment-editor/section-enrollment-editor';
import { BreadcrumbsComponent } from '../../../ui/admin/breadcrumbs/breadcrumbs.component';

@Component({
	selector: 'app-section-enrollment',
	imports: [SectionEnrollmentEditor, BreadcrumbsComponent],
	standalone: true,
	templateUrl: './section-enrollment.html',
	styleUrl: './section-enrollment.scss',
})
export class SectionEnrollment {}
